import { change } from 'redux-form'

// Action Types
const REQUEST_DATA = 'steppingblocks/careerSearch/REQUEST'
const DATA_SUCCESS = 'steppingblocks/careerSearch/SUCCESS'
const DATA_FAILURE = 'steppingblocks/careerSearch/FAILURE'
const PURGE_DATA = 'steppingblocks/careerSearch/PURGE_DATA'

// Reducer
const initialState = {
  requestStarted: false,
  requestEnded: false,
  error: null,
  data: null,
  searchTerm: null,
  company: null,
}

export default (reduxState = initialState, action) => {
  const { type, payload, company, searchTerm } = action
  switch (type) {
    case REQUEST_DATA:
      return {
        ...reduxState,
        requestStarted: true,
        requestEnded: false,
        error: null,
      }
    case DATA_SUCCESS:
      return {
        ...reduxState,
        requestEnded: true,
        data: payload.data,
        company,
        searchTerm,
      }
    case DATA_FAILURE:
      return {
        ...reduxState,
        requestEnded: true,
        error: payload.error,
      }
    case PURGE_DATA:
      return {
        ...reduxState,
        requestStarted: false,
        data: null,
      }
    default:
      return reduxState
  }
}

export const performPurgeData = () => async dispatch => {
  dispatch({ type: PURGE_DATA })
}

export const setCompanyValue = value => async dispatch => {
  dispatch(change('careerSearchForm', 'company', value))
}

export const resetFormValues = () => async dispatch => {
  dispatch(change('careerSearchForm', 'search_query', ''))
  dispatch(change('careerSearchForm', 'company', ''))
  dispatch(change('careerSearchForm', 'state', []))
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/Career/careerDuck.js